import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import Types from "Types";
import {
  Selectors as DossierLocationSelector,
  Selectors as DossierLocationSelectors,
} from "../../../../redux/DossierLocation";
import { Selectors as PartenaireSelector } from "../../../../redux/Partenaire";
import { Selectors as SituationPersonnelleSelector } from "../../../../redux/SituationPersonnelle";
import {
  ActionCreators,
  Selectors as SituationProfessionnelleSelector,
} from "../../../../redux/SituationProfessionnelle";
import {
  useGetListSituationProfessionnelles,
  usePutSituationProfessionnelleUnitaire,
} from "../../../../hooks/SituationProfessionnelle";
import {
  ISituationProfessionnellePresentation,
  SituationProfessionnelleFormData,
  situationProfessionnelleModelToForm,
} from "../helpers";
export const useSituationProfessionnelle = () => {
  const {
    data: listSituationProfessionnelle,
    isLoading: fetching,
    error,
  } = useGetListSituationProfessionnelles();
  const situationProfessionnelle = useSelector((state: Types.RootState) =>
    SituationProfessionnelleSelector.getSituationProfessionnelle(state)
  );
  const situationPersonnelle = useSelector((state: Types.RootState) =>
    SituationPersonnelleSelector.getSituationPersonnelle(state)
  );
  const modifSituationProData = useSelector((state: Types.RootState) =>
    DossierLocationSelectors.getSituationProData(state)
  );
  const compositionLocation = useSelector((state: Types.RootState) =>
    DossierLocationSelector.getCompositionLocation(state)
  );

  const compositionLocationFormEnCours = useSelector((state: Types.RootState) =>
    SituationPersonnelleSelector.getCompositionLocation(state)
  );
  const situationProData =
    situationProfessionnelle && listSituationProfessionnelle
      ? situationProfessionnelleModelToForm(
          situationProfessionnelle,
          listSituationProfessionnelle,
          compositionLocationFormEnCours || compositionLocation
        )
      : modifSituationProData;

  const [initialValues, setInitialValues] =
    useState<SituationProfessionnelleFormData | undefined>();

  useEffect(() => {
    if (situationProData) {
      setInitialValues(situationProData);
    }
  }, []);
  const [hasConjoint, setHasConjoint] = useState<boolean>(false);
  const dispatch = useDispatch();

  const isControleDossier = useSelector((state: Types.RootState) =>
    PartenaireSelector.getControleDossier(state)
  );

  const dossierLocation = useSelector((state: Types.RootState) =>
    DossierLocationSelector.getDossierLocation(state)
  );

  const refDossierLocation = useSelector((state: Types.RootState) =>
    DossierLocationSelector.getSelectedDossier(state)
  );

  const selectedPerson = useSelector((state: Types.RootState) =>
    DossierLocationSelector.getSelectedPerson(state)
  );

  const isCumulsUtilises = useSelector((state: Types.RootState) =>
    PartenaireSelector.getCumulsUtilises(state)
  );

  const {
    mutate: putSituationPro,
    isSuccess: isSuccessSituationPro,

    variables: situationProPrincipal,
    error: errorSituationPro,
    isLoading: fetchingSituationPro,
    reset: resetSituationPro,
  } = usePutSituationProfessionnelleUnitaire();

  const {
    mutate: putSituationProSecondaire,
    isSuccess: isSuccessSituationProSecondaire,
    variables: situationProSecondaire,
    error: errorSituationProSecondaire,
    isLoading: fetchingSituationProSecondaire,
    reset: resetSituationProSecondaire,
  } = usePutSituationProfessionnelleUnitaire();

  const [conjoint, setConjoint] =
    useState<
      | undefined
      | {
          dossierLocationRef?: string;
          dossierParticulierRef: string;
          situationProfessionnelle: ISituationProfessionnellePresentation;
          prefixe: "principal" | "secondaire";
        }
    >(undefined);
  const ajouterSituationProfessionnelle = (
    params: SituationProfessionnelleFormData
  ) => {
    const { principal, secondaire } = params;

    // récupération de la référence de la personne
    const refDossierParticulierPrincipal =
      principal.reference ||
      situationPersonnelle?.situationPrincipale?.reference ||
      "";

    if (
      secondaire &&
      (secondaire.statut === "INCOMPLET" ||
        secondaire.statut === "BLOQUE" ||
        secondaire.statut === "")
    ) {
      const refDossierParticulierSecondaire =
        secondaire.reference ||
        situationPersonnelle?.situationConjoint?.reference ||
        "";

      setConjoint({
        dossierLocationRef: refDossierLocation,
        dossierParticulierRef: refDossierParticulierSecondaire,
        situationProfessionnelle: secondaire,
        prefixe: "secondaire",
      });

      // putSituationProSecondaire({
      //   dossierParticulierRef: refDossierParticulierSecondaire,
      //   dossierLocationRef: refDossierLocation,
      // g  situationProfessionnelle: secondaire,
      //   prefixe: "secondaire",
      // });
    }
    if (
      principal &&
      (principal.statut === "INCOMPLET" ||
        principal.statut === "BLOQUE" ||
        principal.statut === "")
    ) {
      putSituationPro({
        dossierLocationRef: refDossierLocation,
        dossierParticulierRef: refDossierParticulierPrincipal,
        situationProfessionnelle: principal,
        prefixe: "principal",
      });
    } else {
      if (
        secondaire &&
        (secondaire.statut === "INCOMPLET" ||
          secondaire.statut === "BLOQUE" ||
          secondaire.statut === "")
      ) {
        const refDossierParticulierSecondaire =
          secondaire.reference ||
          situationPersonnelle?.situationConjoint?.reference ||
          "";
        // si le dossier principal est validé mais pas le conjoint
        // il faut quand même appeler le conjoint
        putSituationProSecondaire({
          dossierLocationRef: refDossierLocation,
          dossierParticulierRef: refDossierParticulierSecondaire,
          situationProfessionnelle: secondaire,
          prefixe: "secondaire",
        });
      }
    }
  };

  const navigate = useNavigate();
  useEffect(() => {
    if (isSuccessSituationPro) {
      if (conjoint) {
        if (
          conjoint &&
          (conjoint.situationProfessionnelle.statut === "INCOMPLET" ||
            conjoint.situationProfessionnelle.statut === "BLOQUE" ||
            conjoint.situationProfessionnelle.statut === "")
        ) {
          putSituationProSecondaire(conjoint);
        }
      } else {
        situationProPrincipal?.situationProfessionnelle &&
          dispatch(
            ActionCreators.addOrUpdateSituationProfessionnelleAsync({
              principal: situationProPrincipal?.situationProfessionnelle,
              // secondaire: situationProSecondaire?.situationProfessionnelle,
            })
          );
        if (isControleDossier) {
          navigate("/dossier-location/pieces-justificatives");
        } else {
          navigate("/dossier-location/synthese");
        }
      }
    }
  }, [isSuccessSituationPro]);

  useEffect(() => {
    if (isSuccessSituationProSecondaire) {
      situationProPrincipal?.situationProfessionnelle &&
        dispatch(
          ActionCreators.addOrUpdateSituationProfessionnelleAsync({
            principal: situationProPrincipal?.situationProfessionnelle,
            secondaire: situationProSecondaire?.situationProfessionnelle,
          })
        );
      if (isControleDossier) {
        navigate("/dossier-location/pieces-justificatives");
      } else {
        navigate("/dossier-location/synthese");
      }
    }
  }, [isSuccessSituationProSecondaire]);
  return {
    initialValues,
    ajouterSituationProfessionnelle,
    errorSituationPro,
    errorSituationProSecondaire,
    fetchingSituationPro,
    fetchingSituationProSecondaire,
    listSituationProfessionnelle,
    fetching,
    error,
    dossierLocation,
    resetSituationPro,
    resetSituationProSecondaire,
    isControleDossier,
    compositionLocation,
    compositionLocationFormEnCours,
    selectedPerson,
    isCumulsUtilises,
  };
};
